import { render, staticRenderFns } from "./customer_top_items.vue?vue&type=template&id=04670390&scoped=true&"
import script from "./customer_top_items.vue?vue&type=script&lang=js&"
export * from "./customer_top_items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04670390",
  null
  
)

export default component.exports